<script setup lang="ts">
import { useAppState } from '@/stores/AppState'
const appState = useAppState()
</script>
<template>
  <div class="grid mobile-view" id="secHomeMobile">
    <v-card
      v-for="(feature, index) in appState.$state.discovery?.features.filter(
        (f) => f.componentName !== null && f.permission === 'HasAccess'
      )"
      :key="index"
      :to="feature.defaultPath"
      id="secHomeMobileCard"
    >
      <v-container class="d-flex flex-column pb-0" style="align-items: center">
        <v-icon
          style="font-size: xxx-large"
          :style="{ color: 'var(--accent-color)' }"
          id="secHomeMobileCardIcon"
        >
          {{ feature.materialDesignIconName }}
        </v-icon>
      </v-container>
      <v-card-title class="d-inline-block text-truncate centered" id="secHomeMobileCardTitle">
        {{ feature.name }}
      </v-card-title>
      <v-card-text class="d-inline-block text-truncate centered" id="secHomeMobileCardSubtitle">
        {{ feature.description }}
      </v-card-text>
    </v-card>
  </div>
</template>
<style scoped>
.mobile-view {
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 1rem;
  margin-bottom: 5%;
}
</style>
